import { Component } from '@verndale/core';

class Footer extends Component {
  private footerObserver: IntersectionObserver;

  constructor(el: HTMLElement) {
    super(el);
    this.footerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            (this.dom.backToTopBtn as HTMLElement).classList.remove('sticky');
          } else if (window.scrollY >= 600 && !entry.isIntersecting) {
            (this.dom.backToTopBtn as HTMLElement).classList.add('sticky');
          }
        });
      }, {
      threshold: 0,
      rootMargin: '0px'
    }
    );

    this.footerObserver.observe(this.el);
  }

  setupDefaults() {
    this.dom = {
      backToTopBtn: this.el.querySelector<HTMLElement>('.footer__back-top-btn'),
    }
  }

  addListeners() {
    (this.dom.backToTopBtn as HTMLElement).addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', () => {
      if (window.scrollY <= 600) {
        (this.dom.backToTopBtn as HTMLElement).classList.add('sticky');
      } 

      if (window.scrollY == 0) {
        (this.dom.backToTopBtn as HTMLElement).classList.remove('sticky');
      }
    });
  }
}

export default Footer;
